import React, { Component } from 'react';
import { FaMinusCircle } from 'react-icons/fa';

import { Row, Label, Input } from '../../../../../../assets/styles';

class Fields extends Component {
  render() {
    const { id, focused, error } = this.props;
    const { label, desc } = this.props.item;

    if (focused) this.onFocus = focused;
    else this.onFocus = false;

    return (
      <Row>
        <div className="row-2" style={{ alignItems: 'center' }}>
          <Label>
            <p className="fieldName">Título</p>
            <Input
              type="text"
              name="name"
              value={label}
              error={error}
              onFocusInput={this.onFocus.type === 'label'}
              onChange={e => this.props.handleInputChange('label', e.target.value, id)}
              onFocus={() => this.props.onFocus('label', id)}
              onBlur={() => this.props.onBlur()}
            />
          </Label>
          <Label>
            <p className="fieldName">Descrição</p>
            <Input
              className="desc-input"
              type="text"
              name="name"
              value={desc}
              error={error}
              onFocusInput={this.onFocus.type === 'desc'}
              onChange={e => this.props.handleInputChange('desc', e.target.value, id)}
              onFocus={() => this.props.onFocus('desc', id)}
              onBlur={() => this.props.onBlur()}
            />
          </Label>
          <button type="button" className="delete-btn" onClick={() => this.props.deleteItem(id)}>
            <FaMinusCircle className="fa fa-minus-circle" />
            <span>Remover</span>
          </button>
        </div>
      </Row>
    );
  }
}

export default Fields;
